import { render, staticRenderFns } from "./ReturnChart.vue?vue&type=template&id=586a5e14&"
import script from "./ReturnChart.vue?vue&type=script&lang=js&"
export * from "./ReturnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports